// @flow

import styled, { css } from 'styled-components';
import { media } from '../../../../helpers';
import type { Theme } from '../../../../types';

export default styled<any, Theme>('div')`
  display: flex;
  flex-direction: column;
  padding-top: 0.5rem;
  width: 100%;

  ${media.lg(css`
    flex-direction: row;
  `)}

  ${media.xl(css`
    width: auto;
    border-left: 1px solid ${props => props.theme.pdbInfo.borderColor};
    flex-direction: column;
    padding-top: 0;
    justify-content: center;
    padding-left: 1rem;
  `)}
`;
